// extracted by mini-css-extract-plugin
export default {"step2":"Checkout_step2__ug+Zl","card":"Checkout_card__uxTwt"};